// Helpers for play animation (interpolate position along waypoints)

// Build a route timeline: list of [x,y] segments with cumulative time fractions
// based on euclidean distance so movement is constant speed.
export function buildSegments(start, waypoints) {
  const pts = [start, ...(waypoints || [])];
  const segs = [];
  let totalDist = 0;
  for (let i = 0; i < pts.length - 1; i++) {
    const a = pts[i];
    const b = pts[i + 1];
    const d = Math.hypot(b.x - a.x, b.y - a.y);
    segs.push({ from: a, to: b, dist: d });
    totalDist += d;
  }
  // Normalize: assign t0 and t1 to each segment (0..1)
  let acc = 0;
  for (const s of segs) {
    s.t0 = totalDist > 0 ? acc / totalDist : 0;
    acc += s.dist;
    s.t1 = totalDist > 0 ? acc / totalDist : 1;
  }
  return { segs, totalDist };
}

// Interpolate position at given progress (0..1)
export function positionAt(segments, progress) {
  if (!segments.length) return null;
  // Find segment whose [t0,t1] contains progress
  const t = Math.max(0, Math.min(1, progress));
  let s = segments[segments.length - 1];
  for (const seg of segments) {
    if (t <= seg.t1) { s = seg; break; }
  }
  const span = s.t1 - s.t0 || 1;
  const localT = (t - s.t0) / span;
  return {
    x: s.from.x + (s.to.x - s.from.x) * localT,
    y: s.from.y + (s.to.y - s.from.y) * localT,
  };
}

// Precompute segments map for a play (by slot_id)
export function buildRouteCache(play) {
  if (!play?.routes) return {};
  const cache = {};
  for (const r of play.routes) {
    const { segs } = buildSegments(r.start, r.waypoints);
    cache[r.slot_id] = { segments: segs, route: r };
  }
  return cache;
}
